import * as React from 'react';
const BlefariteIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M61.81 114.57c-4.03-4.29-7.37-9.3-9.81-14.89 8.35-19.11 27.19-31.45 48-31.45s39.65 12.34 48 31.45c-8.35 19.11-27.19 31.44-48 31.44-3.57 0-7.09-.36-10.5-1.06"
      className="prefix__cls-1"
    />
    <circle cx={100} cy={100.32} r={24.83} className="prefix__cls-2" />
    <path
      d="M114.9 100.32c0 8.24-6.65 14.9-14.9 14.9s-14.9-6.65-14.9-14.9c0-1.06.1-2.09.33-3.08a8.3 8.3 0 0 0 4.64 1.42c4.57 0 8.28-3.71 8.28-8.28 0-1.72-.53-3.31-1.42-4.64.99-.23 2.02-.33 3.08-.33 8.24 0 14.9 6.65 14.9 14.9Z"
      className="prefix__cls-2"
    />
    <circle cx={67.94} cy={121.13} r={3.37} className="prefix__cls-1" />
    <circle cx={73.85} cy={127.2} r={4.57} className="prefix__cls-1" />
    <circle cx={82.52} cy={128.35} r={2.25} className="prefix__cls-1" />
  </svg>
);
export default BlefariteIcon;
